/**
 * Deli data index file
 * Exports all deli-related data
 */

const deliMeats = require('./deliMeats');
const deliCheeses = require('./deliCheeses');
const deliBreads = require('./deliBreads');
const deliCondiments = require('./deliCondiments');
const deliSmokedFish = require('./deliSmokedFish');
const deliHomemadeSalads = require('./deliHomemadeSalads');
const deliSaladPlates = require('./deliSaladPlates');
const deliSoups = require('./deliSoups');
const deliSpecialties = require('./deliSpecialties');
const deliTreats = require('./deliTreats');
const deliFridgeItems = require('./deliFridgeItems');

// Group all deli data categories together
const deliData = {
  meats: deliMeats,
  cheeses: deliCheeses,
  breads: deliBreads,
  condiments: deliCondiments,
  fish: deliSmokedFish,
  homemadeSalads: deliHomemadeSalads,
  saladPlates: deliSaladPlates,
  soups: deliSoups,
  specialties: deliSpecialties,
  treats: deliTreats,
  fridgeItems: deliFridgeItems
};

module.exports = deliData;